import { axiosServiceAddress } from 'axiosClient/axiosClient';
import { ListResponseAddress } from 'common/@types';
import { District, Province, Ward } from 'common/models';
import { ROUTES_API_ADDRESS } from 'constants/routesApiKeys';
import { NavigateFunction } from 'react-router-dom';
import { setMessageError } from 'redux/auth/authSlice';
import { handleResponseMessage } from 'utils';

interface OpenApiProvince {
  code: number;
  name: string;
  division_type: string;
  districts?: OpenApiDistrict[];
}

interface OpenApiDistrict {
  code: number;
  name: string;
  wards?: OpenApiWard[];
}

interface OpenApiWard {
  code: number;
  name: string;
}

const mapProvince = (province: OpenApiProvince): Province => ({
  province_id: String(province.code),
  province_name: province.name,
  province_type: province.division_type,
});

const mapDistrict = (district: OpenApiDistrict): District => ({
  district_id: String(district.code),
  district_name: district.name,
});

const mapWard = (ward: OpenApiWard): Ward => ({
  ward_id: String(ward.code),
  ward_name: ward.name,
});

export const getAllProvincesThunk = async (navigate: NavigateFunction, thunkAPI: any) => {
  try {
    const response: OpenApiProvince[] = await axiosServiceAddress.get(ROUTES_API_ADDRESS.GET_ALL_PROVINCE);
    const provinces = response.map(mapProvince);
    return { results: provinces } as ListResponseAddress<Province>;
  } catch (error: any) {
    const messageMultiLang = handleResponseMessage('Cannot load provinces.');
    thunkAPI.dispatch(setMessageError(messageMultiLang));
    return thunkAPI.rejectWithValue(error);
  }
};

export const getAllDistrictByProvinceIdThunk = async (params: any, thunkAPI: any) => {
  const { provinceId } = params;

  try {
    const response: OpenApiProvince = await axiosServiceAddress.get(
      ROUTES_API_ADDRESS.GET_ALL_DISTRICT_BY_PROVINCE_ID(Number(provinceId))
    );
    const districts = (response.districts || []).map(mapDistrict);
    return { results: districts } as ListResponseAddress<District>;
  } catch (error: any) {
    const messageMultiLang = handleResponseMessage('Cannot load districts.');
    thunkAPI.dispatch(setMessageError(messageMultiLang));
    return thunkAPI.rejectWithValue(error);
  }
};

export const getAllWardByDistrictIdThunk = async (params: any, thunkAPI: any) => {
  const { districtId } = params;

  try {
    const response: OpenApiDistrict = await axiosServiceAddress.get(
      ROUTES_API_ADDRESS.GET_ALL_WARD_BY_DISTRICT_ID(Number(districtId))
    );
    const wards = (response.wards || []).map(mapWard);
    return { results: wards } as ListResponseAddress<Ward>;
  } catch (error: any) {
    const messageMultiLang = handleResponseMessage('Cannot load wards.');
    thunkAPI.dispatch(setMessageError(messageMultiLang));
    return thunkAPI.rejectWithValue(error);
  }
};
